import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import { InsightServiceLibrary } from 'library/InsightServiceLibrary';
// import * as msal from 'msal';
import React from 'react';
import { RuntimeEnvironment } from 'startup/getRuntimeEnvironment';

interface IAppContextProps {
  insightApi: InsightServiceLibrary;
  clientApp: PublicClientApplication;
  runtimeConfig: RuntimeEnvironment;
  pageLoadTimestamp: number;
}

interface IAppContext extends IAppContextProps {
  userAccount: AccountInfo | null;
  setUserAccount: (user: AccountInfo) => void;
}

const initialRuntimeConfig: RuntimeEnvironment = {
  apiURL: '',
  identityServiceAuthorityUrl: '',
  relativeBasePath: '',
  identityServiceClientId: '',
  b2cDomainHost: '',
  lookupAppId: '',
  cesAppId: '',
  docsAppId: '',
  googleAnalyticsId: '',
};

const defaultClientApp = new PublicClientApplication({
  auth: {
    clientId: '',
  },
});

const defaultInsightApi = new InsightServiceLibrary({
  clientApp: defaultClientApp,
  runtimeEnvironment: initialRuntimeConfig,
});

export const AppContext = React.createContext<IAppContext>({
  insightApi: defaultInsightApi,
  runtimeConfig: initialRuntimeConfig,
  clientApp: defaultClientApp,
  pageLoadTimestamp: Date.now(),
  userAccount: null,
  setUserAccount: x => {},
});

export const AppContextProvider: React.FunctionComponent<IAppContextProps> = props => {
  const [userAccount, setUserAccount] = React.useState<AccountInfo | null>(null);
  const { children, ...rest } = props;
  return (
    <AppContext.Provider
      value={{
        ...rest,
        userAccount,
        setUserAccount,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return React.useContext(AppContext);
};
